import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'
import { i18nInstance } from '~/plugins/localization'
const setUserAccountDetails = (dispatch, payload) => {
  dispatch('useraccount/applyDetails', {
    fiscalId: payload.fiscalPeriod.id,
    companyId: payload.company.id,
    customerId: (payload.customer || {}).id
  }, { root: true })
}

const KEYS = {
  Prepare: 'prepare',
  SetFiscalPeriod: 'set-fiscal-period',
  SetWorkshop: 'set-workshop',
  SetSalaryPeriod: 'set-salary-period'
}
const state = {
  user: {
    id: 0,
    name: '...',
    operationClaims: []
  },
  company: {
    id: 0,
    name: '...',
    currency: {
      id: 0,
      name: '...'
    }
  },
  fiscalPeriod: {
    id: 0,
    name: '...'
  },
  customer: {
    id: 0,
    name: '...'
  },
  commercialAccess: {
    customerInformation: {},
    modules: []
  },
  salaryPeriod: {
    isLocked: true,
    isMain: true,
    displayName: "...",
    id: 0,
    date: null,
  },
  workshop: {
    id: 0,
    name: '...'
  },
  clientDifferenceDateTimeByServer: null
}

export const mutations = {
  [KEYS.Prepare](state, context) {
    if (context == null) {
      return
    }
    state.user = context.user
    state.company = context.company
    state.customer = context.customer
    state.fiscalPeriod = context.fiscalPeriod
    state.commercialAccess = context.commercialAccess
    state.workshop = context.workshop
    state.salaryPeriod = context.salaryPeriod
    state.clientDifferenceDateTimeByServer = context.clientDifferenceDateTimeByServer
  },
  [KEYS.SetFiscalPeriod](state, fiscal) {
    state.fiscalPeriod = fiscal
  },
  [KEYS.SetSalaryPeriod](state, salaryPeriod) {
    state.salaryPeriod = salaryPeriod
  },
  [KEYS.SetWorkshop](state, workshop) {
    state.workshop = workshop
  }
}

export const actions = {
  async refresh({ dispatch, commit, state }, options) {
    options = _.extend({ force: false }, options)

    var key = 'app.context'

    if (options.force !== true) {
      var cached = await dispatch('cache/get', key, { root: true })

      if (cached != null) {
        cached = _.extend({
          user: {},
          company: {},
          fiscalPeriod: {},
          customer: {},
          commercialAccess: {},
          workshop: {},
          salaryPeriod: {}
        }, cached)
        commit(KEYS.Prepare, cached)
        setUserAccountDetails(dispatch, cached)
        return
      }
    }

    var result = await post(Endpoints.getUrl('general.statusBar'), null, null, { ignoreCommercialAccess: true })
    if (result.success) {
      let d = _.omitBy(result.data, _.isNull)
      d = _.extend({
        user: {},
        company: {},
        fiscalPeriod: {},
        customer: {},
        commercialAccess: {},
        workshop: {},
        salaryPeriod: {},
        clientDifferenceDateTimeByServer: new Date(d.serverDateTime) - new Date()
      }, d)

      var cacheObj = {
        key,
        seconds: 24 * 60 * 60,
        value: d
      }

      dispatch('cache/set', cacheObj, { root: true })
      commit(KEYS.Prepare, cacheObj.value)
      setUserAccountDetails(dispatch, cacheObj.value)
    }
  },
  async setFiscalPeriod({ dispatch, commit, state }, fiscal) {
    var result = await post(Endpoints.getUrl('user.RefreshToken'), { fiscalPeriodId: fiscal.id })
    if (result.success) {
      commit(KEYS.SetFiscalPeriod, fiscal)

      let payload = {
        user: result.data,
        fiscalId: result.data.additionalData['NIKAN_APP_FISCAL'],
        companyId: result.data.additionalData['NIKAN_APP_COMPANY'],
        workshopId: result.data.additionalData['NIKAN_APP_WORKSHOP'],
        salaryPeriodId: result.data.additionalData['NIKAN_APP_SALARYPERIOD'],
      }
      dispatch('useraccount/clearAll', null, { root: true })
      dispatch('useraccount/applyDetails', payload, { root: true })

      // let res = await dispatch('refresh', { force: true })
      return ''
    } else {
      throw new Error('unable to change fiscal-period')
    }
  },
  async setWorkshop({ dispatch, commit, state }, workshop) {
    var result = await post(Endpoints.getUrl('user.RefreshToken'), { workshopId: workshop.id, salaryPeriodId: state.salaryPeriod?.id })
    if (result.success) {
      commit(KEYS.SetWorkshop, workshop)

      let payload = {
        user: result.data,
        fiscalId: result.data.additionalData['NIKAN_APP_FISCAL'],
        companyId: result.data.additionalData['NIKAN_APP_COMPANY'],
        workshopId: result.data.additionalData['NIKAN_APP_WORKSHOP'],
        salaryPeriodId: result.data.additionalData['NIKAN_APP_SALARYPERIOD'],
      }
      dispatch('useraccount/clearAll', { root: true })
      dispatch('useraccount/applyDetails', payload, { root: true })

      // let res = await dispatch('refresh', { force: true })
      return ''
    } else {
      throw new Error('unable to change fiscal-period')
    }
  },
  async setSalaryPeriod({ dispatch, commit }, salaryPeriod) {
    var result = await post(Endpoints.getUrl('user.RefreshToken'), { salaryPeriodId: salaryPeriod.id })
    if (result.success) {
      commit(KEYS.SetSalaryPeriod, salaryPeriod)

      let payload = {
        user: result.data,
        fiscalId: result.data.additionalData['NIKAN_APP_FISCAL'],
        companyId: result.data.additionalData['NIKAN_APP_COMPANY'],
        workshopId: result.data.additionalData['NIKAN_APP_WORKSHOP'],
        salaryPeriodId: result.data.additionalData['NIKAN_APP_SALARYPERIOD'],
      }
      dispatch('useraccount/clearAll', { root: true })
      dispatch('useraccount/applyDetails', payload, { root: true })

      // let res = await dispatch('refresh', { force: true })
      return ''
    } else {
      throw new Error('unable to change fiscal-period')
    }
  }
}
export const getters = {
  getClientDifferenceDateTimeByServer: state => state.clientDifferenceDateTimeByServer,
  getUser: state => state.user,
  getCompany: state => state.company,
  getCommercialAccess: state => state.commercialAccess,
  getCurrent: state => state.company.currency,
  getFiscalPeriod: state => state.fiscalPeriod,
  getWorkshop: state => state.workshop,
  getSalaryPeriod: state => state.salaryPeriod,
  userHasPermission: state => token => {
    if (state.customer.userId === state.user.id) return true // user is owner
    //sa
    return state.user.operationClaims.some(t => t.key.toLowerCase() === token.toLowerCase())
    // return state.user.operationClaims.map(x => x.key).filter(t => t.toLowerCase() === token.toLowerCase()).length > 0
  },
  checkCommercialAccess: state => token => {
    if (_.isString(token) && !token.length || !state.commercialAccess.modules)
      return true

    if (Array.isArray(token))
      return state.commercialAccess.modules.some(x => token.includes(x.typeKey) && x.isActive)

    return state.commercialAccess.modules.filter(x => x.typeKey === token && x.isActive).length > 0
  },
  checkCommercialAccessDetailed: (state, getters) => token => {
    if (_.isString(token) && !token.length)
      return {
        value: true,
        type: 'Active',
      }

    const checkAccess = (tk) => {

      const module = state.commercialAccess.modules.find(x => x.typeKey === tk)

      if (!module)
        return {
          value: false,
          type: 'InvalidToken',
          message: i18nInstance.global.t('commercialAccess.invalid-token', { token: tk }),
        }

      if (getters.checkCommercialAccess(module.typeKey))
        return {
          value: true,
          type: 'Active',
          typeName: module.typeName,
          message: i18nInstance.global.t('commercialAccess.plan-has-access', { typeName: module.typeName }),
        }
      else if (module.startDate && !module.isActive)
        return {
          value: false,
          type: 'Expired',
          typeName: module.typeName,
          message: i18nInstance.global.t('commercialAccess.plan-expired', { typeName: module.typeName }),
        }
      return {
        value: false,
        type: 'NotPurchased',
        typeName: module.typeName,
        message: i18nInstance.global.t('commercialAccess.plan-not-purchased', { typeName: module.typeName }),
      }
    }

    if (Array.isArray(token)) {
      const res = token.map(x => checkAccess(x))
      const typeNames = res.map(x => x.typeName)

      if (res.some(x => x.value))
        return {
          value: true,
          type: 'Active',
          typeName: typeNames,
          message: i18nInstance.global.t('commercialAccess.plan-has-access'),
        }

      return {
        value: false,
        type: 'AtleastOneModuleRequired',
        typeName: typeNames,
        message: i18nInstance.global.t('commercialAccess.at-least-one-module-requried', { typeNames: typeNames }),
      }
    }

    return checkAccess(token)
  },

  checkAccessAccountBalanceObserve: (state, getters) => {
    return getters.userHasPermission('Accounting_Account_WatchBalance')
  },
  checkAccessFloatingCentersBalanceObserve: (state, getters) => {
    return getters.userHasPermission('Accounting_FloatingCenters_WatchBalance')
  },
  checkAccessProductBalanceObserve: (state, getters) => {
    return getters.userHasPermission('Product_Product_WatchBalance')
  },
  checkAccessChequeOperationAmountAndPriceObserve: (state, getters) => {
    return getters.userHasPermission('Treasury_ChequeOperation_WatchAmountAndPrice')
  },
  checkAccessSaleBuyFactorListObserveFinancialColumn: (state, getters) => {
    return getters.userHasPermission('SaleBuy_FactorList_ObserveFinancialColumn')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
